import styled from 'styled-components'

export const IdeaSelectContainer = styled.div`
	width: 100%;
`

export const IdeaLabel = styled.label`
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #374151;
	margin-bottom: 8px;
`

export const IdeaSelectWrapper = styled.div`
	position: relative;
	width: 100%;
`

export const IdeaInput = styled.input`
	width: 100%;
	padding: 12px 40px 12px 16px;
	font-size: 16px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	outline: none;
	background-color: white;
	cursor: pointer;
	transition: border-color 0.2s;

	&:focus {
		border-color: #f97316;
		cursor: text;
	}

	&:read-only {
		cursor: pointer;
	}

	&::placeholder {
		color: #9ca3af;
	}
`

export const SearchIcon = styled.div`
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: #6b7280;
	pointer-events: none;
	display: flex;
	align-items: center;
	justify-content: center;
`

export const IdeaDropdown = styled.div<{ $top: number; $left: number; $width: number }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $left }) => $left}px;
	width: ${({ $width }) => $width}px;
	background: white;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	max-height: 300px;
	overflow-y: auto;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
	z-index: 10000;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: #f3f4f6;
		border-radius: 8px;
	}

	&::-webkit-scrollbar-thumb {
		background: #d1d5db;
		border-radius: 8px;

		&:hover {
			background: #9ca3af;
		}
	}
`

export const IdeaDropdownItem = styled.div<{ $isSelected: boolean }>`
	padding: 12px 16px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: 4px;
	background-color: ${props => (props.$isSelected ? '#fff7ed' : 'white')};
	border-bottom: 1px solid #f3f4f6;

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background-color: ${props => (props.$isSelected ? '#ffedd5' : '#f9fafb')};
	}

	&:active {
		background-color: #ffedd5;
	}
`

export const IdeaName = styled.span`
	font-weight: 500;
	color: #111827;
	font-size: 14px;
`

export const IdeaDetails = styled.span`
	color: #6b7280;
	font-size: 13px;
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`

export const IdeaCategory = styled.span`
	color: #f97316;
	font-size: 12px;
	font-weight: 500;
`

export const EmptyState = styled.div`
	padding: 24px 16px;
	text-align: center;
	color: #6b7280;
	font-size: 14px;
`

